import { InstagramIcon, AppleIcon, SpotifyIcon, WavesIcon } from '@/components/Icons';
import { useSize } from 'ahooks';
export default function PlayerCard() {
  const size = useSize(document.querySelector('body')) ?? { width: 400, height: 0 };

  return (
    <section className="flex flex-col justify-center items-center">
      <div className="flex flex-col md:flex-row gap-8 items-center">
        <div className="w-full px-4">
          <p className="mt-4 text-[20px] max-w-3xl leading-[140%] tracking-[-5%]">
            Imogen Heap, a British artist, has spent 30 years self-producing music, releasing four solo albums and one with Frou Frou. She
            has collaborated with Taylor Swift, Deadmau5, and others. Her songs appear in films, TV, and are widely sampled in rap and
            dance. Heap has won two Grammys, an Ivor Novello, and pioneered the MiMu Gloves for gestural music control.
          </p>

          <div className="mt-4 flex gap-6">
            <a href="#" className="opacity-70 hover:opacity-100 transition-opacity">
              <AppleIcon />
            </a>
            <a href="#" className="opacity-70 hover:opacity-100 transition-opacity">
              <SpotifyIcon />
            </a>
            <a href="#" className="opacity-70 hover:opacity-100 transition-opacity">
              <InstagramIcon />
            </a>
            <a href="https://tidal.com/browse/artist/3475" className="opacity-70 hover:opacity-100 transition-opacity">
              <WavesIcon />
            </a>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="w-full flex justify-center">
            <iframe
              style={{ borderRadius: '12px' }}
              src="https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO46XXI6?utm_source=generator&theme=0"
              width={size?.width - 32}
              height="352"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
